import { render, staticRenderFns } from "./newAbout.vue?vue&type=template&id=500f036c&scoped=true&"
import script from "./newAbout.vue?vue&type=script&lang=js&"
export * from "./newAbout.vue?vue&type=script&lang=js&"
import style0 from "./newAbout.vue?vue&type=style&index=0&id=500f036c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500f036c",
  null
  
)

export default component.exports